"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientModuleExecutor = void 0;
var siteAssetsRequestLogger_1 = require("./siteAssetsRequestLogger");
var siteAssetsPagesInfoResolver_1 = require("./siteAssetsPagesInfoResolver");
var objectHelper_1 = require("./helper/objectHelper");
var siteAssetsClientValidation_1 = require("./siteAssetsClientValidation");
var makeModuleExecutor = require('site-assets-module-executor');
exports.ClientModuleExecutor = function (config, collaborators, siteModels, urlBuilder) {
    /**
     * The module validator is a no op because there is no access to the module whitelist
     * The server will validate
     */
    var noOpModuleValidator = {
        validate: function () { return Promise.resolve(); }
    };
    var buildParams = function (request) {
        var params = urlBuilder.siteAssetsParams(request);
        return objectHelper_1.stringifyValues(params);
    };
    var execute = function (request) {
        try {
            siteAssetsClientValidation_1.validateSiteAssetsSiteModels(siteModels);
        }
        catch (e) {
            return Promise.reject(e);
        }
        var moduleExecutorCollaborators = {
            moduleValidator: noOpModuleValidator,
            metricsReporter: collaborators.metricsReporter,
            moduleFetcher: function () { return collaborators.moduleFetcher; },
            httpClient: collaborators.httpClient // todo get the new module from module-executor (shahar will fix) that uses the httpClient
        };
        var moduleExecutorConfig = {
            moduleConfig: config.moduleFetchTopology,
            staticsConfig: config.staticsTopology,
            topology: config.mediaTopology
        };
        var moduleExecutor = makeModuleExecutor({
            config: moduleExecutorConfig,
            collaborators: moduleExecutorCollaborators
        }).moduleExecutor;
        var moduleExecutionParams = {
            query: buildParams(request),
            pagesInfoResolver: siteAssetsPagesInfoResolver_1.PagesInfoResolver(siteModels.sitePagesModel),
            clientSpecMap: siteModels.metaSiteModel.clientSpecMap,
            logger: collaborators.logger || siteAssetsRequestLogger_1.logger // todo get the new module from module-executor (shahar will fix) that uses the logger
        };
        return moduleExecutor(request.endpoint.controller).execute(moduleExecutionParams);
    };
    return {
        execute: execute
    };
};
